// ProductList.js
// Component for Product List

// Imports
import React from 'react';
import { Colors } from '@blueprintjs/core';
import PropTypes from 'prop-types';
import Product from './Product';
import QuickAdd from './QuickAdd';
import Adjustment from './Adjustment';
import OrderData from '../../data/Order';

// Component Class
// Shows a list of products
class ProductList extends React.Component {
  // Sets the order data for a given product
  setQuantity = (pId, unitId, quantity, customPrice) => {
    var cId = this.props.clientId;
    this.props.setOrderProduct(cId, pId, unitId, quantity, customPrice);
  }

  // Sets the adjustment value and description of the current order
  setAdjustment = (value, description) => {
    var cId = this.props.clientId;
    this.props.setOrderAdjustment(cId, value, description);
  }

  // Returns an OrderData object for the associated order
  getOrderData = () => {
    var clientId = this.props.clientId;
    return new OrderData(this.props.products, this.props.order.byClient[clientId]);
  }

  // Returns whether a given product should be rendered
  filterProduct = (pId) => {
    if (this.props.filterEmpty) {
      var orderData = this.getOrderData();
      return orderData.getProductTotal(pId) > 0;
    }
    return true;
  }

  // Renders Component
  render() {
    var ids = this.props.products.ids.slice();
    ids.sort((a, b) => {
      var nameA = this.props.products.byId[a].name;
      var nameB = this.props.products.byId[b].name;
      return nameA.localeCompare(nameB);
    });
    var clientId = this.props.clientId;
    var orderData = this.getOrderData();
    return (
      <div>
        <QuickAdd products={this.props.products} setProduct={this.setQuantity} />
        <br />
        <Adjustment orderData={orderData} key={this.props.clientId} setAdjustment={this.setAdjustment} />
        <br />
        <table className="pt-html-table pt-html-table-striped pt-small" style={{width: '90%'}}>
          <thead>
            <tr>
              <th style={{width: '20%'}}>
                Produto
              </th>
              <th style={{width: '15%'}}>
                <center>Quantidade</center>
              </th>
              <th style={{width: '20%'}}>
                <center>Unidade</center>
              </th>
              <th style={{width: '15%'}}>
                <center>Preço Unitário</center>
              </th>
              <th style={{width: '15%'}}>
                <center>Negociado</center>
              </th>
              <th style={{width: '15%'}}>
                <center>Total</center>
              </th>
            </tr>
          </thead>
          <tbody>
            {ids.map(id => this.filterProduct(id) &&
              <Product
                key={clientId + "/" + id}
                id={id}
                clientId={clientId}
                order={this.props.order.byClient[clientId]}
                orderData={orderData}
                products={this.props.products}
                product={this.props.products.byId[id]}
                setQuantity={this.setQuantity}
              />
            )}
            <tr style={{fontSize: 16}}>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td style={{textAlign: "right"}}>
                <b>Total</b>
              </td>
              <td style={{backgroundColor: Colors.BLUE5}}>
                <center>
                  <b>R$ {orderData.getTotal().toFixed(2)}</b>
                </center>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}

// Required Properties
ProductList.propTypes = {
  clientId: PropTypes.number.isRequired,
  clients: PropTypes.object.isRequired,
  products: PropTypes.object.isRequired,
  order: PropTypes.object.isRequired,
  filterEmpty: PropTypes.bool.isRequired,
  setOrderProduct: PropTypes.func.isRequired,
  setOrderAdjustment: PropTypes.func.isRequired,
}

// Exports
export default ProductList;


// WEBPACK FOOTER //
// ./src/components/OrderView/ProductList.js